<div class="offscreen">
  <ul class="main-level">
    <div class="item clickable" *ngIf="(shouldShowSuperiorButtons | async)" [routerLink]="['/main/dashboard/management-panel']">Dashboard</div>
    <div class="item clickable" *ngIf="(shouldShowSuperiorButtons | async)" [routerLink]="['/main/notification-center']">Central de Notificações</div>
    <div class="item -drop" *ngIf="(shouldShowSuperiorButtons | async)">
      Configurações
      <div class="level-1">
        <a [routerLink]="['/main/settings/digital-certificate']" class="item" (click)="closeMenu()">Certificado
          Digital</a>
        <a [routerLink]="['/main/settings/accountant-registration']" class="item" (click)="closeMenu()">Cadastro do
          Contador</a>
        <a [routerLink]="['/main/settings/companies-obligations']" class="item" (click)="closeMenu()">Cadastro de Empresas
          e Obrigações</a>
        <a [routerLink]="['/main/settings/uploader/download']" class="item" (click)="closeMenu()">Download do
          Uploader</a>
      </div>
    </div>
    <div class="item -drop"> Conta
      <div class="level-1">
        <a appLogout class="item">Sair</a>
      </div>
    </div>
  </ul>
</div>